import React, { useState, useEffect } from "react";
import Filter from "../../components/Filter/Filter";
import {
    fetchAPIData,
    getCompanyId,
    getToken,
    getUser,
    generateHiddenColumns,
    copyToClipboard,
    assetsPermissionOptions
} from '../../Utils/Common';
import Table, { renderCellExpand } from '../../components/Table/Table';
import Divider from '@mui/material/Divider';
import Tooltip from "@mui/material/Tooltip";
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import InfoIcon from '@mui/icons-material/Info';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import { FormDialog } from "../../components/FormDialog/FormDialog";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import "../pages.scss";
import axios from 'axios';

const idpStatusSchemaView = require("../../json/idpStatusSchema.json").view;
const idpWorkflowStatusSchemaView = require("../../json/idpWorkflowStatusSchema.json").view;

const uiSchema = {
    "failedTaskNames": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "tasks": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        },
        "items": {
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false
            }
        }
    },
    "input": {
        "ui:options": {
            widget: "textarea",
            rows: 10
        }
    },
    "output": {
        "ui:options": {
            widget: "textarea",
            rows: 7
        }
    }
};

const uiSchemaIdpWorkflowStatus = {
    "failedReferenceTaskNames": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "failedTaskNames": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    },
    "errorMessage": {
        "ui:options": {
            widget: "textarea",
            rows: 2
        }
    },
    "tasks": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        },
        "items": {
            "outputData": {
                "ui:options": {
                    widget: "textarea",
                    rows: 7
                }
            },
            "errorMessage": {
                "ui:options": {
                    widget: "textarea",
                    rows: 2
                }
            }
        }
    }
};

const DocumentIDPStatusTabPanel = ({ setNotify }) => {

    const [cspApiData, setCspApiData] = useState([]);
    const [coreApiData, setCoreApiData] = useState([]);
    const [envisionApiData, setEnvisionApiData] = useState([]);
    const [rowJsonData, setRowJsonData] = useState({});
    const [idpWorkflowStatusJsonData, setIdpWorkflowStatusJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [openIdpWorkflowStatusDialog, setOpenIdpWorkflowStatusDialog] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [idpWorkflowStatusMode, setIdpWorkflowStatusMode] = useState('view');  // default to view mode

    const [reload, setReload] = useState(false);
    const [origination, setOrigination] = useState('CSP'); // default to CSP
    const [isLoading, setIsloading] = useState(false);

    // API URL is dynamic in that COMPANY_ID is replaced
    const apiURL = `/api/companies/%COMPANY_ID%/idp/workflows?origination=${origination}&`;

    const idpWorkflowInstructions = "Click the 'Status' cell link in order to view IDP workflow status";

    const fieldData = [
        'batchId',
        'documentGUID'
    ];

    const filterOperators = [
        {
            label: 'EQUALS(=)',
            value: '='
        }
    ];

    const [idpCspStatus, setIdpCspStatus] = usePersistentStorage("idpCspStatus", []);
    const [idpCoreStatus, setIdpCoreStatus] = usePersistentStorage("idpCoreStatus", []);
    const [idpEnvisionStatus, setIdpEnvisionStatus] = usePersistentStorage("idpEnvisionStatus", []);

    useEffect(() => {
        // check if localstorge had data for the current tab
        if (origination === 'CSP') {
            setCspApiData(idpCspStatus);
        }
        if (origination === 'CORE') {
            setCoreApiData(idpCoreStatus);
        }
        if (origination === 'ENVISION') {
            setEnvisionApiData(idpEnvisionStatus);
        }

    }, []);

    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            field: 'companyId',
            hideable:false,
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            field: 'workflowId',
            hideable:false,
            headerName: 'Workflow ID',
            minWidth: 350,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: "300px" }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy workflow ID" onClick={(event) => copyToClipboard(event, params.row.workflowId)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'correlationId',
            hideable:false,
            headerName: 'Correlation ID',
            minWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            // renderCell: renderCellExpand
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: "250px" }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy correlation ID" onClick={(event) => copyToClipboard(event, params.row.correlationId)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'workflowType',
            hideable:false,
            headerName: 'Workflow Type',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'documentGUID',
            hideable:false,
            headerName: 'Document GUID',
            minWidth: 350,
            maxWidth: 350,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '300px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy document GUID" onClick={(event) => copyToClipboard(event, params.row.documentGUID)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'batchId',
            hideable:false,
            headerName: 'Batch ID',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            field: 'status',
            hideable:false,
            headerName: 'Status',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            cellClassName: 'state-header',
            renderCell: (params) => {
                return (
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => {
                            // get json data
                            fetchIdpWorkflowStatus(params.row.companyId, params.row.workflowId);
                        }}
                    >
                        {params.value}
                    </Link>
                );
            },
            renderHeader: (params) => {
                return (
                    <>
                        <span style={{ fontWeight: 500 }}>{params.colDef.headerName}</span>
                        <Tooltip title={idpWorkflowInstructions} arrow placement="top">
                            <InfoIcon style={{ verticalAlign: 'middle', marginLeft: '5px' }} />
                        </Tooltip>
                    </>
                );
            }
        },
        {
            field: 'startTime',
            hideable:false,
            headerName: 'Start Time',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'endTime',
            hideable:false,
            headerName: 'End Time',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'reasonForIncompletion',
            hideable:false,
            headerName: 'Reason For Incompletion',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left', wordBreak: 'break-word' }}>
                        {params.value}
                    </div>
                );
            }
        },
        {
            field: 'failedReferenceTaskNames',
            hideable:false,
            headerName: 'Failed Reference Task Names',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left', wordBreak: 'break-word' }}>
                        {params.value}
                    </div>
                );
            }
        },
        {
            field: 'failedTaskNames',
            hideable:false,
            headerName: 'Failed Task Names',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
                        {params.value && params.value.map((item) => <>{item}<br /></>)}
                    </div>
                );
            }
        }
    ];

    const handleChange = (event) => {
        setOrigination(event.target.value);
    };

    const fetchData = async (apiURL2, qparams) => {
        //console.log('inside fetch customer data:', qparams);

        /*
        let message = "Loading customer data ...";
     
        setNotify({
            isOpen: true,
            message: message,
            severity: 'info'
        });
    */
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                // console.log("Updating table data: ", data);
                // append companyId, documentGUID, and batchId to table data so values are accessible from row data
                let data2 = data.map((object) => {
                    let objData = JSON.parse(object.input);

                    let companyId = objData.PAYLOAD.tags.companyId;
                    let documentGUID = objData.PAYLOAD.tags.docId;
                    let batchId = objData.PAYLOAD.tags.batchId;
                    return { ...object, companyId: Number(companyId), documentGUID, batchId };
                });

                if (origination === 'CSP') {
                    setCspApiData(data2);
                    setIdpCspStatus(data2);
                } else if (origination === 'CORE') {
                    setCoreApiData(data2);
                    setIdpCoreStatus(data2);
                } else if (origination === 'ENVISION') {
                    setEnvisionApiData(data2);
                    setIdpEnvisionStatus(data2);
                } else {
                    console.log("Unknown origination type: ", origination);
                }

                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load document idp status data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                if (origination === 'CSP') {
                    setCspApiData([]);
                } else if (origination === 'CORE') {
                    setCoreApiData([]);
                } else if (origination === 'ENVISION') {
                    setEnvisionApiData([]);
                }
                setReload(false);
                setIsloading(false);
            });
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setRowJsonData(JsonData);
        setMode('view');
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const fetchIdpWorkflowStatus = (companyId, workflowId) => {
        let idpWorkflowStatusUrl = `/api/companies/${companyId}/idp/workflows/${workflowId}`;

        axios({
            method: "GET", url: idpWorkflowStatusUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {
                // add company id so it is displayed in json data
                response.data.companyId = Number(companyId);
                const JsonData = response.data;

                formatData(JsonData);

                setIdpWorkflowStatusJsonData(JsonData);
                setIdpWorkflowStatusMode('view');
                setOpenIdpWorkflowStatusDialog(true);

            }).catch(error => {
                console.log('error in fetch idp workflow status api call:', error);

                let message = `Failed to fetch idp workflow status for workflow [${companyId}, ${workflowId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

            });
    };

    const handleIdpWorkflowStatusClose = () => {
        setOpenIdpWorkflowStatusDialog(false);
    };

    const getApiData = () => {
        if (origination === 'CSP') {
            return cspApiData;
        } else if (origination === 'CORE') {
            return coreApiData;
        } else if (origination === 'ENVISION') {
            return envisionApiData;
        } else {
            return [];
        }
    };

    const formatData = (data) => {
        // check if object is not empty
        if (Object.keys(data).length !== 0) {
            data.startTime = data.startTime > 0 ? new Date(data.startTime).toISOString() : "";
            data.endTime = data.endTime > 0 ? new Date(data.endTime).toISOString() : "";

            data.tasks.forEach((obj) => {
                obj.startTime = obj.startTime > 0 ? new Date(obj.startTime).toISOString() : "";

                obj.endTime = obj.endTime > 0 ? new Date(obj.endTime).toISOString() : "";

                obj.scheduledTime = obj.scheduledTime > 0 ? new Date(obj.scheduledTime).toISOString() : "";

                // convert object to JSON string format
                obj.outputData = JSON.stringify(obj.outputData, null, 2);
            });
        }
    };

    return (
        <>
            <div id="idpStatusDocumentfilterContainer" style={{ marginTop: '0px', marginLeft: '16px' }}>

                <div style={{ display: 'flex' }}>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="idp status origination radio buttons"
                            name="origination-radio-buttons-group"
                            value={origination}
                            onChange={handleChange}
                        >
                            <FormControlLabel value="CSP" control={<Radio size="small" />} label="CSP" />
                            <FormControlLabel value="CORE" control={<Radio size="small" />} label="Core" />
                            <FormControlLabel value="ENVISION" control={<Radio size="small" />} label="enVision" />
                        </RadioGroup>
                    </FormControl>
                </div>

                <Filter permission={assetsPermissionOptions} fields={fieldData} filterOperators={filterOperators} apiURL={apiURL} fetchData={fetchData} setNotify={setNotify} reload={reload} useCompanyId={true} includeTotalDisplay={false} includeSort={false} tabName={'documentIdpStatusTab'} />
            </div>


            <Divider />

            <div id="idpStatusTableContainer" >
                <div >
                    <Table data={getApiData()} columns={columns} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>


            {/* This dialog only support view. No need for form or save */}
            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                title="IDP Status Task Information"
                defaultTab='JSON'
                propertiesTabContent={
                    <FormDialog
                        formId={'IdpStatusTaskDialogId'}
                        readOnly={true}
                        schema={idpStatusSchemaView}
                        uiSchema={uiSchema}
                        formData={rowJsonData}
                    />
                }
                jsonDataName="idp status tasks"
                JSONTabContent={rowJsonData}
            />

            {/* This dialog only support view. No need for form or save */}
            <ActionDialog
                open={openIdpWorkflowStatusDialog}
                mode={idpWorkflowStatusMode}
                onClose={handleIdpWorkflowStatusClose}
                title="IDP Workflow Status Information"
                defaultTab='JSON'
                propertiesTabContent={
                    <FormDialog
                        formId={'IdpWorkflowStatusDialogId'}
                        readOnly={true}
                        schema={idpWorkflowStatusSchemaView}
                        uiSchema={uiSchemaIdpWorkflowStatus}
                        formData={idpWorkflowStatusJsonData}
                    />
                }
                jsonDataName="idp workflow status"
                JSONTabContent={idpWorkflowStatusJsonData}
            />

        </>
    );
}

export default DocumentIDPStatusTabPanel;